import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'alert-modal',
	template: require('./alert-modal.component.html'),
	styles: [require('./alert-modal.component.scss')]
})
export class AlertModalComponent {
	@Input() title: string;
	@Input() message: string;

	constructor(private ngbActiveModal: NgbActiveModal) {}

	closeModal(): void {
		this.ngbActiveModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/alert-modal/alert-modal.component.ts